import React, { useState } from 'react';
import { get, post } from "../Services/http";
import CustomModal from "./CustomModal";
import { translate } from "../Services/translation";
import button from "./Button";
import { useSelector, useDispatch } from 'react-redux';
import { setOpen } from "../Actions/CountryPicker.action";

function CountryPicker() {
    const open = useSelector((state) => state.countryPicker.isOpen);
    const countryCode = useSelector((state) => state.countryPicker.countryCode);
    const countries = useSelector((state) => state.countryPicker.countries);
    const hasSelectedCountry = useSelector((state) => state.countryPicker.hasSelectedCountry);

    const dispatch = useDispatch();

    const [selectedCountry, setSelectedCountry] = useState(countryCode);

    function selectCountry(country) {
        if(country === countryCode){
            dispatch(setOpen(false));

            return;
        }

        post('/api/countries', {
            country: country
        }).then(() => {
            window.location.reload()
        })
    }

    return (
        <CustomModal
            size='large'
            isOpen={open} onClose={() => dispatch(setOpen(false))}
            title={translate('countrypicker.title')}
            description={translate('countrypicker.description')}
            hideCloseButton={!hasSelectedCountry}
        >
            <div>
                <div className="modal__form-container">
                    <div className="modal__input-container modal__input-container--fullwidth-mobile">
                        {
                            countries.map((x, index) => <button onClick={() => {
                                hasSelectedCountry ? setSelectedCountry(x.code) : selectCountry(x.code)
                            }}
                                                                className={"modal__tag " + (selectedCountry === x.code && hasSelectedCountry ? "modal__tag--selected" : " ")}
                                                                key={index}>{translate('countrypicker.' + x.code.toLowerCase())}</button>)
                        }
                    </div>
                </div>
                {
                    hasSelectedCountry && <button
                        className="modal__submit-button modal__submit-button--fullwidth-mobile"
                        onClick={() => selectCountry(selectedCountry)}>{translate('countrypicker.submit')}
                    </button>
                }
            </div>
        </CustomModal>
    );
}

export default CountryPicker;
